<template>
  <div id="ModalCreate">
    <transition name="fade">
      <div class="fixed inset-0 z-50" v-if="isCreateModalVisible">
        <div>
          <div
            class="absolute inset-0 bg-black bg-opacity-75"
            @click="onCreateToggle"
          ></div>
          <div
            class="flex flex-col items-center justify-center w-screen h-screen"
          >
            <div
              class="relative animodal-inner bg-white rounded-md overflow-y-auto"
            >
              <div
                v-if="!caseCreationSuccessMessage"
                class="mt-3 mx-3 text-center"
              >
                Create User
              </div>
              <div class="pb-4">
                <div class="text-center px-7 lg:px-12">
                  <div v-if="caseCreationSuccessMessage">
                    <div class="text-center">
                      <div class="">
                        <font-awesome-icon
                          class="text-green-600 z-20 h-20 w-20 py-2"
                          icon="fa-check-circle"
                        />
                      </div>
                      <div class="py-2">
                        <div class="p-4 text-black">
                          <div class="text-lg font-bold text-center">
                            User request created successfully
                          </div>

                          <div class="mt-4 text-sm text-center font-normal">
                            Kindly track processing status from Tickets menu
                            using Case Number
                            <div class="block font-bold">
                              {{ caseCreationSuccessMessage }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="createCaseError" class="text-center">
                    <div class="">
                      <font-awesome-icon
                        class="text-red-600 z-20 h-20 w-20 py-2"
                        icon="fa-exclamation-circle"
                      />
                    </div>
                    <div class="py-2">
                      <div class="p-4 text-black">
                        <div class="text-lg font-bold text-center">
                          User creation request failed
                        </div>
                        <div class="mt-4 text-sm text-center font-bold">
                          {{ createCaseError }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <form
                  v-if="!caseCreationSuccessMessage"
                  @submit.prevent="createContactCase"
                  :class="{ valid: !v$.$error && v$.$dirty, error: v$.$error }"
                >
                  <div
                    v-if="caseCreationError"
                    class="text-center bg-red-600 text-white p-3"
                  >
                    {{ caseCreationError }}
                  </div>
                  <div
                    class="m-3 mx-14 lg:mx-3 xl:m-3 w-full xl:lg:w-96 lg:w-96"
                  >
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> First Name
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactFirstName"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactFirstName?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">First Name is required</div>
                      </div>
                    </div>
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> Last Name
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactLastName"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactLastName?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">Last Name is required</div>
                      </div>
                    </div>
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> Designation
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactDesignation"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactDesignation?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">Designation is required</div>
                      </div>
                    </div>
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> Department
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactDepartment"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactDepartment?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">Department is required</div>
                      </div>
                    </div>
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> E-mail Address
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactEmail"
                          type="email"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactEmail?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">Email is required</div>
                      </div>
                    </div>
                    <div class="my-4">
                      <p class="block text-gray-700 text-sm font-bold mb-2">
                        <span class="text-red-500">*</span> Phone Number
                      </p>
                      <div class="flex">
                        <input
                          v-model="state.contactMobile"
                          type="number"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                      <div
                        class="input-errors text-sm text-red-500 mt-1"
                        v-for="error of v$.contactMobile?.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg">Phone number is required</div>
                      </div>
                      <div class="flex" style="display: none">
                        <input
                          v-model="type"
                          class="shadow appearance-none w-full border bg-gray-200 rounded py-2 px-2 text-gray-800 leading-tight focus:outline-none focus:shadow-outline"
                        />
                      </div>
                    </div>
                    <div class="p-3 mt-2 text-center space-x-4 md:block">
                      <button
                        :disabled="caseLoading"
                        @click.prevent="onCreateToggle"
                        class="mb-2 md:mb-0 bg-black px-5 py-2 text-sm shadow-sm font-medium tracking-wider text-white rounded-md hover:shadow-lg"
                      >
                        Close
                      </button>
                      <button
                        :disabled="caseLoading"
                        :class="caseLoading ? 'bg-gray-500' : 'bg-[#8DC63F]'"
                        type="submit"
                        class="mb-2 md:mb-0 px-5 py-2 text-sm shadow-sm font-medium tracking-wider border text-white rounded-md hover:shadow-lg"
                      >
                        <span v-if="caseLoading">Creating</span>
                        <span v-else>Create User</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { useStore } from "vuex";
import { engageAxios, toolkitAxios } from "@/env";
export default {
  props: {
    isCreateModalVisible: Boolean,
    onCreateToggle: Function,
    // caseLoading: Boolean,
  },
  setup() {
    const store = useStore();
    const caseCreationError = ref("");
    const createCaseError = ref("");
    const caseCreationSuccessMessage = ref("");
    const type = ref(2);
    const caseLoading = ref(false);
    const interactionCategory = ref("");
    const interactionSubCategory = ref("");
    const state = reactive({
      contactFirstName: "",
      contactLastName: "",
      contactEmail: "",
      contactMobile: "",
      contactDesignation: "",
      contactDepartment: "",
    });

    const rules = {
      contactFirstName: { required },
      contactLastName: { required },
      contactEmail: { required },
      contactMobile: { required },
      contactDesignation: { required },
      contactDepartment: { required },
    };

    const v$ = useVuelidate(rules, state);

    const createContactCase = async () => {
      v$.value.$touch();

      if (v$.value.$invalid) return;

      caseLoading.value = true;

      const updateType = [
        "",
        "",
        "Contact Creation",
        "Contact Update",
        "Contact Deletion",
      ];

      let action;

      if (type.value === 2) {
        action = "Creation";
        interactionCategory.value = "718b7c3e-081d-eb11-a813-000d3a64a52d";
        interactionSubCategory.value = "871a48b7-081d-eb11-a813-000d3a64a52d";
      } else if (type.value === 3) {
        action = "Update";
        interactionCategory.value = "718b7c3e-081d-eb11-a813-000d3a64a52d";
        interactionSubCategory.value = "88f698cf-081d-eb11-a813-000d3a64a52d";
      }

      const finalDesc =
        store.state.getLoggedInUser.code +
        "-" +
        updateType[type.value] +
        " \n " +
        "First Name: " +
        state.contactFirstName +
        " \n " +
        "Last Name: " +
        state.contactLastName +
        " \n " +
        "Email: " +
        state.contactEmail +
        " \n " +
        "Mobile Number: " +
        state.contactMobile +
        " \n " +
        "Designation: " +
        state.contactDesignation +
        " \n " +
        "Department: " +
        state.contactDepartment +
        " \n " +
        "Action: " +
        action +
        " \n ";

      const finalDto = {
        caseOriginCode: "700000008",
        employerCode: store.state.getLoggedInUser.code,
        interactionType: "700000000",
        interactionCategory: interactionCategory.value,
        interactionSubCategory: interactionSubCategory.value,
        documents: [],
        caseDescription: finalDesc,
        // agentCode: store.state.getLoggedInUser.rmu_code,
        subject:
          store.state.getLoggedInUser.code + "-" + updateType[type.value],
      };

      await engageAxios
        .post("crm/case/employer/createcase", finalDto)
        .then((res) => {
          const postData = {
            code: finalDto.employerCode,
            type: type.value,
            agentCode: store.state.getLoggedInUser.rmu_code,
          };
          // console.log(postData)

          if (res.data.status === "success") {
            toolkitAxios
              .post("case/contact", postData)
              .then(() => {
                caseCreationSuccessMessage.value = res.data?.data?.caseNumber;
                // caseCreationSuccessMessage.value = `Case Created Successfully, kindly track your Request Status using your Case Number: ${res.data?.response?.caseNumber}`;

                caseLoading.value = false;

                state.contactFirstName = "";
                state.contactLastName = "";
                state.contactEmail = "";
                state.contactMobile = "";
                state.contactDesignation = "";
                state.contactDepartment = "";

                // emit("toggleCreateModal");

                v$.value.$reset();
              })
              .catch(() => {
                caseCreationError.value =
                  "Error in creating case, please try again";
                caseLoading.value = false;
                // console.log("I show face o");
              });
          } else {
            caseCreationError.value =
              "Error in creating case, please try again";

            caseLoading.value = false;
          }
        })
        .catch(() => {
          createCaseError.value = "Error in creating case, please try again";
          caseLoading.value = false;
        });
    };

    return {
      caseLoading,
      state,
      createContactCase,
      caseCreationError,
      caseCreationSuccessMessage,
      createCaseError,
      type,
      v$,
    };
  },
};
</script>

<style></style>
